(ns common.widgets.progress
  (:require ["@mui/material/LinearProgress$default" :as LinearProgress]
            ["@mui/material/Stack$default" :as Stack]
            [uix.core :refer [$ defui]]))

(defui linear-progress-with-label [{:keys [sx value]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 1
      :sx sx}
     ($ LinearProgress
        {:variant "determinate"
         :value value
         :sx #js {:flex 1}})
     (str value "%")))
